module.exports = __webpack_public_path__ + "static_pc/img/wx3.d985703b.png";